export default __webpack_public_path__ + "static/media/img18.3b23e297.jpg";